module.exports = __webpack_public_path__ + "static/media/Screen Shot 2017-12-10 at 5.59.13 PM.5c2179be.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/shifting/Screen Shot 2017-12-10 at 5.59.13 PM.png
// module id = 124
// module chunks = 0